import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { Typography } from '@/components/Contentful'
import { memo } from 'react'

function stripCodeMarks(textContent) {
  if (!textContent?.json) return textContent
  const processNode = (node) => {
    const result = { ...node }
    if (result.marks?.length) {
      result.marks = result.marks.filter((m) => m.type !== 'code')
    }
    if (result.content?.length) {
      result.content = result.content.map(processNode)
    }
    return result
  }
  return { ...textContent, json: processNode(textContent.json) }
}

const BasicDisclaimerModule = memo(function BasicDisclaimerModule({ config, richTextDisclaimer }) {
  const { title, disclaimer } = config || {}
  return (
    <Section
      disableGutters={true}
      data-testid="basic-disclaimer-section"
      className="pb-12 pt-8  lg:pt-12 lg:pb-20 "
      childContainerClassName="px-4 sm:px-8"
    >
      <div className="grid grid-cols-4 gap-x-8 gap-y-0 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 breakpointLg:gap-x-8 breakpointLg:gap-y-0 breakpointXl:grid-cols-12 breakpointXl:gap-x-8 breakpointXl:gap-y-0">
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12">
          {title && !richTextDisclaimer && (
            <Typography
              content={title}
              variant="headingMd"
              className="font-bold md:headingLg m-auto leading-[120%]! text-left pb-8"
              data-testid="basic-disclaimer-title"
              component="h2"
            />
          )}
          {(richTextDisclaimer || disclaimer) && (
            <Typography
              content={richTextDisclaimer || disclaimer}
              variant="bodyMd"
              className="bodyMd md:bodyLg m-auto leading-[140%]! text-left"
              data-testid="basic-disclaimer-disclaimer"
            />
          )}
        </div>
      </div>
    </Section>
  )
})

function BasicDisclaimer({ content }) {
  const { config, richTextDisclaimer } = useMemoizedContentGetter(content, [
    'config',
    'richTextDisclaimer',
  ])
  return (
    <BasicDisclaimerModule
      config={config?.jsonContent || {}}
      richTextDisclaimer={stripCodeMarks(richTextDisclaimer?.textContent)}
    />
  )
}

export { BasicDisclaimer, BasicDisclaimerModule }
export default BasicDisclaimer
